<template>
  <span>
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <!--          
          <v-text-field
              v-bind:value="value"
              v-on:input="(event)=>$emit('input', event)"                    
              :label="campo.cmp_titulo"
              required
              :hint="campo.cmp_dica"
              persistent-hint 
          ></v-text-field>
      -->

      <v-icon
        v-if="showvalue||imgDataUrl"
        style="float:left;"
        color="red"
        @click="remover()"
        :title="T('Excluir')"
        dark
      >delete</v-icon>

      <v-avatar tile @click="toggleShow" size="100" color="grey lighten-4">
        <img :src="imgDataUrl" v-if="imgDataUrl" />
        <img :src="endpoint+`/admin/content/arquivo/${showvalue}`" v-else-if="showvalue" />
      </v-avatar>

      <v-btn small class="primary" @click="toggleShow">{{T('Carregar imagem')}}</v-btn>

      <my-upload
        field="file"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :width="width"
        :height="height"
        :url="endpoint+'/admin/upload/foto/upload'"
        :params="params"
        :headers="headers"
        langType="pt-br"
        :noRotate="false"
        :img-format="format"
      ></my-upload>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <v-dialog v-model="dialog" max-width="600">
        <v-card style="position:relative;">
          <v-btn style="position:absolute;z-index:1;right:0px;" @click="dialog=false;" icon>
            <v-icon>close</v-icon>
          </v-btn>
          <img :src="endpoint+`/admin/content/arquivo/${value}`" />
        </v-card>
      </v-dialog>

      <v-avatar
        v-if="value"
        size="60"
        color="grey lighten-4 ma-1"
        @click="dialog=!dialog"
        style="cursor:pointer;"
      >
        <img :src="endpoint+`/admin/content/arquivo/${value}`" />
      </v-avatar>
    </template>

    <template v-if="modo=='filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
      ></v-text-field>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

import myUpload from "vue-image-crop-upload";

export default {
  extends: _baseComponent,
  data() {
    return {
      dialog: false,
      show: false,
      intravalue: this.value,
      width: this.getComponentParam("width") || 200,
      height: this.getComponentParam("height") || 200,
      format: this.getComponentParam("format") || "png",
      endpoint: global.config.endpoint,
      params: {},
      headers: {},
      imgDataUrl: null, // the datebase64 url of created image
    };
  },
  components: {
    "my-upload": myUpload,
  },
  computed: {
    showvalue() {
      if (this.value == null) return null;

      return this.value.split("\n")[0];
    },
    showname() {
      if (this.value == null) return null;

      return this.value.split("\n")[1];
    },
  },

  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    remover() {
      this.intravalue = null;
    },
    cropSuccess(data) {
      this.imgDataUrl = data;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);

      this.intravalue = jsonData.data.file;
      this.show = false;
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
  },

  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
    },
  },
};
</script>

<style >
.vicp-img {
  max-width: none !important;
}
</style>

    